module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-overflow/theme/lui-overflow.global.scss
// module id = 284
// module chunks = 0 1 29